const options = {
  5: "bg-blue-700/5",
  10: "bg-blue-700/10",
  25: "bg-blue-700/25",
  50: "bg-blue-700/50",
  75: "bg-blue-700/75",
  90: "bg-blue-700/90",
  100: "bg-blue-700",
};

const from = {
  5: "from-blue-700/5",
  10: "from-blue-700/10",
  25: "from-blue-700/25",
  50: "from-blue-700/50",
  75: "from-blue-700/75",
  90: "from-blue-700/90",
  100: "from-blue-700",
};

export default function getBackgroundBlue700(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
